import React, { useState, useEffect } from "react";
import { Alert, AlertHeading, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";

import { api } from "./pureFunctions";
import {
   getStaticData,
   parseOODate,
   parseOODateTime,
   teamsGLTerminNachricht,
   teamsMessageFunctions,
} from "./pureFunctions";
import { getAppointments, getAppointmentsWithLocations } from "./networkFunctions";
import { header, host } from "./globalVariables";
import { useConfig } from "./ConfigContext";
import { useAuth } from "./AuthContext";
import { useM365Context } from "./m365Context";

const calenderInterval = ["-", 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
const initTerminData = {
   datum_von: new Date(),
   datum_bis: new Date(new Date().getTime() + 7 * 24 * 3600000),
   duration: 0,
   zeitslot: false,
};
const terminslot = 10 * 60000;

export default function GeschaeftfuehrerMeeting({}) {
   const { user } = useAuth();
   const config = useConfig();
   const { postMsTeamsTeamMessage } = useM365Context();

   const [loading, setLoading] = useState(false);
   const [terminData, setTerminData] = useState(initTerminData);
   const [terminObjects, setTerminObjects] = useState();
   const [selectedTermin, setSelectedTermin] = useState();
   const [basicDataTermine, setBasicDataTermine] = useState();
   const [availableDays, setAvailableDays] = useState([]);
   const [progress, setProgress] = useState();
   const [users, setUsers] = useState();

   function getBusinessDates(startDate, endDate) {
      let currentDate = new Date(startDate);
      currentDate.setHours(0, 0, 0, 0);
      let newAvailableDays = [];

      while (currentDate <= endDate) {
         let dayOfTheWeek = currentDate.getDay();
         if (dayOfTheWeek !== 0 && dayOfTheWeek !== 6) {
            newAvailableDays.push(new Date(currentDate));
         }
         currentDate.setDate(currentDate.getDate() + 1);
      }
      return newAvailableDays;
   }

   async function notifyGLTermin(notiz, datum) {
      //https://teams.microsoft.com/l/channel/19%3Aba6a08f552234b74a3e2c277171f98f6%40thread.tacv2/GL-Terminierung?groupId=a597b6ed-144a-496d-9e1f-dee799af880e&tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93

      //teams.microsoft.com/l/channel/19%3Ad72a3e2d58e7447296b7f42c3a085e9c%40thread.tacv2/Expos%C3%A9%20Koordination?groupId=a597b6ed-144a-496d-9e1f-dee799af880e&tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93&ngc=true
      // // setLoading("loading");
      const teamsId = import.meta.env.PROD
         ? "a597b6ed-144a-496d-9e1f-dee799af880e"
         : "5f9e0c1e-8a83-4cd1-a2d7-51dfc4825f87";
      const channelId = import.meta.env.PROD
         ? "19%3Aba6a08f552234b74a3e2c277171f98f6%40thread.tacv2"
         : "19%3Abcef8ed598784d59a10ca7fa950d2c86%40thread.tacv2";

      let messageData = {
         body: {
            contentType: "html",
            content: teamsMessageFunctions.adminTerminNachricht({ notiz, datum }),
         },
      };

      await postMsTeamsTeamMessage(teamsId, channelId, messageData);

      setTimeout(() => {
         // setLoading(false);
      }, 1000);
   }

   async function createAppointments(reqData) {
      await api
         .post("/api/createOOAppointment", reqData, header)
         .then((data) => {
            console.log(data);
            setProgress("success");
            window.scrollTo(0, 0);
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            /* setErrorMessage({
                     error: "onOffice",
                     message: JSON.stringify(err.response.data, null, 1),
                  }); */
         });
   }

   async function getTermine() {
      let timeLimit = [];

      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
      setUsers(cleanUserData);
      console.log(cleanUserData);

      timeLimit = parseOODate(terminData.datum_von, terminData.datum_bis);
      let newAvailableDays = getBusinessDates(terminData.datum_von, terminData.datum_bis);
      setAvailableDays(newAvailableDays);

      let parameters = {
         data: ["id", "type", "subject", "notes", "status", "date", "users", "contacts"],
         filter: {
            startDate: timeLimit[0],
            endDate: timeLimit[1],
            isCancelled: false,
            type: [{ op: "IN", val: ["Gesprächszeitraum", "Gesprächszeitraum Belegt"] }],
            userIds: config.glMeetingCalenderUsers,
         },
      };

      console.log(parameters);

      let terminResponse = await getAppointments(parameters);
      console.log(terminResponse);
      console.log(config.glMeetingCalenderUsers);
      let hostTermine = config.glMeetingCalenderUsers.reduce((oldObj, item) => ({ ...oldObj, [item]: {} }), {});

      terminResponse
         .filter((terminIte) => terminIte.elements.type.label === "Gesprächszeitraum Belegt")
         .forEach((item) => {
            /* let currentHost = config.glMeetingCalenderUsers.find((id) =>
               item.elements.users.some((obj) => parseInt(obj.id) === id),
            ); */
            let currentHosts = config.glMeetingCalenderUsers.filter((id) =>
               item.elements.users.some((obj) => parseInt(obj.id) === id),
            );
            currentHosts.forEach((currentHost) => {
               hostTermine[currentHost] = {
                  ...hostTermine[currentHost],
                  [new Date(item.elements.date.start).getTime()]: {
                     ...item,
                     host: currentHost,
                     /* host: config.glMeetingCalenderUsers.find((id) =>
                        item.elements.users.some((obj) => parseInt(obj.id) === id),
                     ), */
                  },
               };
            });
         });

      console.log(hostTermine);
      setTerminObjects(hostTermine);
      let orderedTermine = newAvailableDays.reduce((oldObj, item) => ({ ...oldObj, [item.toDateString()]: [] }), {});

      console.log(orderedTermine);

      terminResponse
         .filter((terminIte) => terminIte.elements.type.label === "Gesprächszeitraum")
         .forEach((item) => {
            let dateKey = new Date(item.elements.date.start).toDateString();
            console.log(item);

            console.log(dateKey);
            console.log(orderedTermine);
            if (orderedTermine[dateKey]) orderedTermine[dateKey] = [...orderedTermine[dateKey], item.elements];
         });

      console.log(orderedTermine);

      setBasicDataTermine(orderedTermine);
   }

   return (
      <>
         <title>{`Meeting ${""}`}</title>
         <div className="m-5 m-5" style={{ position: "relative" }}>
            {/* <h1> buchen</h1> */}
            {progress === "success" && terminData.zeitslot ? (
               <Alert variant="success">
                  <AlertHeading>
                     Der Termin am <strong>{terminData.zeitslot.toLocaleDateString()}</strong> um{" "}
                     <strong>{terminData.zeitslot.toLocaleTimeString()}</strong> wurde eingetragen!
                  </AlertHeading>
               </Alert>
            ) : (
               <>
                  <Form style={{ position: "relative", zIndex: 1000 }}>
                     <Row>
                        <Form.Group as={Col} className="mb-3" controlId="notiz">
                           <Form.Label>Worum geht es?</Form.Label>
                           <Form.Control
                              as="textarea"
                              autoComplete="off"
                              onChange={(e) => setTerminData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                              placeholder=""
                              name="notiz"
                              style={{ height: "200px" }}
                              value={terminData.grundstuecksflaeche}
                           />
                        </Form.Group>
                     </Row>
                     <Row>
                        <Form.Group as={Col} controlId={"datum_von"} className="mb-3">
                           <Form.Label>Wunschdatum von</Form.Label>
                           <DatePicker
                              isClearable
                              selected={terminData.datum_von}
                              onChange={(e) => setTerminData((prev) => ({ ...prev, datum_von: e }))}
                              className={"bootstrap-datepicker"}
                              calendarClassName="custom-date-calendar"
                              dateFormat="dd.MM.yyyy"
                              popperPlacement="bottom"
                              locale="de"
                           />
                        </Form.Group>
                        <Form.Group as={Col} controlId={"datum_bis"} className="mb-3">
                           <Form.Label>bis</Form.Label>
                           <DatePicker
                              isClearable
                              selected={terminData.datum_bis}
                              onChange={(e) => setTerminData((prev) => ({ ...prev, datum_bis: e }))}
                              className={"bootstrap-datepicker"}
                              calendarClassName="custom-date-calendar"
                              dateFormat="dd.MM.yyyy"
                              popperPlacement="bottom"
                              locale="de"
                           />
                        </Form.Group>
                     </Row>
                  </Form>
                  <hr />
                  <div className="d-flex justify-content-end mt-1">
                     <Button
                        disabled={!(terminData.datum_bis && terminData.datum_von)}
                        onClick={() => {
                           getTermine();
                        }}
                     >
                        Termin suchen
                     </Button>
                  </div>
                  <div className="flex-row mt-5" style={{ alignItems: "start" }}>
                     <div className=" flex-col w-75">
                        <div className="calender-frame">
                           <div className="calender-column">
                              {calenderInterval.map((hourItem) => (
                                 <div className="time-row"> {hourItem}</div>
                              ))}
                           </div>

                           {availableDays.map((dayIte) => {
                              let dateKey = dayIte.toDateString();
                              return (
                                 <div className="calender-column">
                                    <div className="user-row" style={{ zIndex: 1 }}>
                                       {dayIte.toLocaleString("de-DE", { weekday: "short" }) +
                                          " " +
                                          dayIte.toLocaleDateString().slice(0, 5)}
                                    </div>

                                    {basicDataTermine &&
                                       basicDataTermine[dateKey] &&
                                       basicDataTermine[dateKey].map((terminItem, index) => {
                                          const startTime = new Date(terminItem.date.start);
                                          const endTime = new Date(terminItem.date.end);
                                          let myHeight = (endTime - startTime) / 60000 + "px";
                                          let myWidth = "100%";
                                          let myMarginLeft = 0;
                                          let myTop = startTime.getHours() * 60 + startTime.getMinutes() - 7 * 60;

                                          let isDisabled = startTime < new Date();

                                          if (
                                             basicDataTermine[dateKey][index - 1] &&
                                             new Date(basicDataTermine[dateKey][index - 1].date.end) > startTime
                                          ) {
                                             myWidth = "50%";
                                          } else if (
                                             basicDataTermine[dateKey][index + 1] &&
                                             new Date(basicDataTermine[dateKey][index + 1].date.start) < endTime
                                          ) {
                                             myWidth = "50%";
                                             myMarginLeft = "50%";
                                             console.log(basicDataTermine[dateKey][index]);
                                          }

                                          const myStyle = {
                                             border: "none",
                                             width: myWidth,
                                             height: myHeight,
                                             marginLeft: myMarginLeft,

                                             fontSize: "calc( 0.1rem + .7vw)",
                                             top: myTop,
                                             backgroundColor: terminItem.type.label.includes("Belegt")
                                                ? `#224c`
                                                : isDisabled
                                                  ? "#aaa"
                                                  : "#a00c",
                                             outline:
                                                selectedTermin && selectedTermin.id === terminItem.id
                                                   ? "dashed 4px #224"
                                                   : "solid 1px #ddd",
                                          };

                                          return (
                                             <button
                                                disabled={user.Name != "JonathanMischke" && isDisabled}
                                                onClick={() => {
                                                   console.log(terminItem);
                                                   let zeitslots = [];
                                                   let endTime = new Date(terminItem.date.end);
                                                   let starttime = new Date(terminItem.date.start).getTime();
                                                   let i = 0;
                                                   let terminHost = terminItem.users.length
                                                      ? terminItem.users[0].id
                                                      : 0;
                                                   let termindauer = terminslot;
                                                   let zeitslot = new Date(terminItem.date.start);
                                                   while (zeitslot < endTime) {
                                                      zeitslot = new Date(starttime + i * termindauer);
                                                      i++;
                                                      zeitslots.push(zeitslot);
                                                   }
                                                   zeitslots.pop();
                                                   console.log({ ...terminItem, zeitslots, terminHost });
                                                   console.log(terminObjects);

                                                   setSelectedTermin({ ...terminItem, zeitslots, terminHost });
                                                }}
                                                title={isDisabled ? "Buchungszeitraum abgelaufen" : null}
                                                className="appointment-row"
                                                style={myStyle}
                                             >
                                                {terminItem.users.map((userIte) => " " + userIte.userName)}
                                             </button>
                                          );
                                       })}
                                 </div>
                              );
                           })}
                        </div>
                     </div>
                     <div className="w-25 ps-5">
                        {selectedTermin && (
                           <div>
                              <h5>Zeitslot auswählen</h5>
                              <div className=" flex-col" style={{ maxHeight: "600px", overflow: "auto" }}>
                                 {selectedTermin.zeitslots.map((zeitslot, index) => {
                                    console.log(selectedTermin);

                                    let selectedHost = parseInt(selectedTermin.users[0].id);
                                    const isDisabled = terminObjects[selectedHost]?.[new Date(zeitslot).getTime()];

                                    return (
                                       <div>
                                          <Button
                                             className="mb-1 w-100"
                                             variant={isDisabled ? "outline-primary" : "primary"}
                                             disabled={isDisabled}
                                             onClick={() => {
                                                console.log(user);

                                                setTerminData((prev) => ({ ...prev, zeitslot: zeitslot }));
                                             }}
                                          >
                                             {zeitslot.toLocaleTimeString().slice(0, -3)}
                                          </Button>
                                          {zeitslot === terminData.zeitslot && !terminData.notiz && (
                                             <div style={{ padding: 20, color: "#a00" }}>
                                                {" "}
                                                Zum Buchen des Termins bitte bei oben bei{" "}
                                                <strong>Worum geht es?</strong> kurz eine Info zum Anliegen eintragen.
                                             </div>
                                          )}
                                          {zeitslot === terminData.zeitslot && (
                                             <div className="mb-5 d-flex justify-content-end">
                                                <Button
                                                   onClick={() => {
                                                      setTerminData((prev) => ({ ...prev, zeitslot: false }));
                                                   }}
                                                   variant="warning"
                                                   className="flex-fill me-2"
                                                >
                                                   Abbrechen
                                                </Button>{" "}
                                                <Button
                                                   disabled={!terminData.notiz || loading}
                                                   onClick={async () => {
                                                      setLoading(true);
                                                      await notifyGLTermin(terminData.notiz, new Date(zeitslot));
                                                      console.log(selectedTermin);

                                                      await createAppointments({
                                                         data: {
                                                            description: "Belegt ",
                                                            start_dt: parseOODateTime(zeitslot),
                                                            end_dt: parseOODateTime(
                                                               new Date(zeitslot).getTime() + terminslot,
                                                            ),
                                                            art: "Gesprächszeitraum Belegt",
                                                            ganztags: false,

                                                            note: terminData.notiz,

                                                            private: false,
                                                         },
                                                         subscribers: {
                                                            users: config.glMeetingCalenderUsers.includes(user.id)
                                                               ? [user.id]
                                                               : [selectedTermin.terminHost, user.id],
                                                         },
                                                      });

                                                      setLoading(false);
                                                   }}
                                                   variant="success"
                                                   className="flex-fill"
                                                >
                                                   {loading && <Spinner size="sm"></Spinner>}{" "}
                                                   {zeitslot.toLocaleTimeString().slice(0, -3)} Uhr Bestätigen
                                                </Button>
                                             </div>
                                          )}
                                       </div>
                                    );
                                 })}
                              </div>
                           </div>
                        )}
                     </div>
                  </div>
               </>
            )}
         </div>
      </>
   );
}
